import { RecaptchaVerifier } from "firebase/auth";
import { auth } from "../firebase";
export const firebaseRecaptchaVerifier = () => {
  let error;
  const appVerifier = (window.recaptchaVerifier = new RecaptchaVerifier(
    auth,
    "recaptcha-container",
    {
      size: "invisible",
      callback: (response) => {},
      "expired-callback": () => {
        error = "reCAPTCHA has expired. Please refresh the page.";
      },
    }
  ));
  return { appVerifier, error };
};
